"use client";

type FlowTableEngineModule = typeof import("@/app/flow-test/IdealTableEngine");

let flowTableEnginePromise: Promise<FlowTableEngineModule> | null = null;

/**
 * Один общий promise для фонового прогрева и для next/dynamic. Так ранний
 * запуск и последующий рендер не создают две независимые загрузки таблицы.
 */
export function loadFlowTableEngineModule(): Promise<FlowTableEngineModule> {
  if (!flowTableEnginePromise) {
    flowTableEnginePromise = import("@/app/flow-test/OptimizedFlowTableEngine").catch(error => {
      flowTableEnginePromise = null;
      throw error;
    });
  }
  return flowTableEnginePromise;
}

export function preloadFlowTableEngineCode(): void {
  void loadFlowTableEngineModule().catch(() => {
    // Прогрев не блокирует страницу: next/dynamic сможет повторить импорт.
  });
}
